export const LOGIN_TOAST_OPTIONS = {
  placement: 'bottom-center',
  wrapperId: 'toast-wrapper-login-form',
} as const;
